import {FileEntry} from "./fileEntry";

export type SubmissionStatus =
  | 'draft' | 'preparing' | 'ready_to_send' | 'sent'
  | 'interview_scheduled' | 'interview_done' | 'won' | 'lost' | 'withdrawn';

export const SUBMISSION_PIPELINE: SubmissionStatus[] = [
  'draft', 'preparing', 'ready_to_send', 'sent', 'interview_scheduled', 'interview_done', 'won', 'lost',
];

export type SubmissionLossReason =
  | 'rate_too_high' | 'candidate_mismatch' | 'insufficient_experience'
  | 'insufficient_availability' | 'location_mismatch' | 'client_withdrew'
  | 'competitor_chosen' | 'submitted_too_late' | 'no_response' | 'unknown' | 'other';

export const SUBMISSION_LOSS_REASONS: SubmissionLossReason[] = [
  'rate_too_high', 'candidate_mismatch', 'insufficient_experience',
  'insufficient_availability', 'location_mismatch', 'client_withdrew',
  'competitor_chosen', 'submitted_too_late', 'no_response', 'unknown', 'other',
];

export interface ApplicationPackage {
  id: number;
  cv_status: string | null;
  letter_status: string | null;
  cv_pdf_gcs_key: string | null;
  letter_pdf_gcs_key: string | null;
}

export interface Submission {
  id: number;
  Opportunity_id: number;
  Client_id: number;
  consultant_User_id: number;
  responsible_User_id?: number | null;
  status: SubmissionStatus;
  GeneratedCv_id?: number | null;
  motivation_text?: string | null;
  loss_reason?: string | null;
  loss_reason_note?: string | null;
  interview_at?: string | null;
  converted_Project_id?: number | null;
  rate_offered?: number | null;
  consultant?: { id: number; name_first: string; name_last: string; logo?: Partial<FileEntry> };
  opportunity?: { id: number; title: string; description?: string | null; effective_description?: string | null; status?: string; Client_id?: number; MarketVacancy_id?: number | null; for_Client_id?: number; end_client?: { id: number; name: string } | null; via_Client_id?: number | null; broker?: { id: number; name: string } | null; rate_target?: number | null };
  cv?: { id: number; pdf_gcs_key: string | null } | null;
  application_package?: ApplicationPackage | null;
}
